import { useEffect, useState } from "react";

import { formatDistance } from "@fwa/src/utils/temporalUtils";

// Empty until mounted so server and client markup match.
export function useTimeAgo(dateTime?: Date | string | null) {
  const [timeAgo, setTimeAgo] = useState("");

  useEffect(() => {
    if (!dateTime) return undefined;
    const timeout = setTimeout(
      () => setTimeAgo(formatDistance(new Date(dateTime), new Date())),
      0,
    );
    return () => clearTimeout(timeout);
  }, [dateTime]);

  return timeAgo;
}

export default useTimeAgo;
